export default {
  functionKey: "NOMPROPRE",
  title: "NOMPROPRE",
  group: "Texte",
  origin: [],
  target: [],
  description: "Mettre en majuscule la première lettre de chaque mot",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.replace(/[A-Za-zÀ-ÖØ-öø-ÿ]+/g, function(w) { return w.charAt(0).toUpperCase() + w.slice(1)} );`;
    return { displayCode: code, safeCode: code };
  }
}
